import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { DECAGON_SIGNATURE_ENDPOINT } from '@perpay-web/constants/urls';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import {
    createDataModuleStateObservable,
    useDataModuleStateObservable,
} from '@perpay-web/data-module/useDataModuleStateObservable';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    fetchDecagonSignature,
    fetchDecagonSignatureSuccess,
    fetchDecagonSignatureError,
    fetchDecagonSignatureReset,
} from '@perpay-web/services/decagon';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const initialValue = {
    isEnabled: false,
    signature: null,
    epoch: null,
    borrowerTier: null,
    hasProvisionedCard: false,
};

export const fetchDecagonSignatureState$ = createDataModuleStateObservable();

const useFetchDecagonSignatureDataModule = () => {
    const dataModule = useDataModule(
        () => authenticatedJsonFetch(DECAGON_SIGNATURE_ENDPOINT),
        {
            initialValue,
        },
    );

    useDataModuleStateObservable(dataModule, fetchDecagonSignatureState$);
    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: fetchDecagonSignature,
        success: fetchDecagonSignatureSuccess,
        error: fetchDecagonSignatureError,
        reset: fetchDecagonSignatureReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useFetchDecagonSignatureDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseFetchDecagonSignatureDataModuleProvider,
    useFetchDecagonSignatureDataModuleContext,
] = createContextProvider(providerFactory);

export const getIsEnabled = (state) => getData(state).isEnabled || false;
export const getSignature = (state) => getData(state).signature || null;
export const getEpoch = (state) => getData(state).epoch || null;
export const getBorrowerTier = (state) => getData(state).borrowerTier || null;
export const getHasProvisionedCard = (state) =>
    getData(state).hasProvisionedCard || false;
